import { CSSProperties, ReactNode } from 'react';
import classnames from 'classnames/bind';

import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface buttonProps {
  type?: 'solid' | 'solid-round' | 'outline' | 'outline-round' | 'text';
  theme?:
    | 'blue'
    | 'black'
    | 'orange'
    | 'green'
    | 'grey'
    | 'light-grey'
    | 'yellow'
    | 'red'
    | 'white'
    | 'blue-green';
  size?: 'small' | 'normal' | 'large' | 'full';
  iconLeft?: any;
  iconRight?: any;
  disabled?: boolean;
  className?: any;
  onClick?: () => void;
  loading?: boolean;
  children: ReactNode;
  style?: CSSProperties;
}

const LoadingEllipse = ({ type, theme }: { type: string; theme: string }) => {
  const loadingEllipseClass = cx({
    'loading-ellipse': true,
    [theme]: true,
    [type]: true,
  });
  return (
    <div className={loadingEllipseClass}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

const Button = ({
  type = 'solid',
  theme = 'blue',
  size = 'normal',
  iconLeft,
  iconRight,
  disabled = false,
  className,
  onClick,
  loading = false,
  children = '',
  style,
}: buttonProps) => {
  const buttonClass = cx({
    button: true,
    [type]: true,
    [size]: true,
    [theme]: true,
    'icon-left': !!iconLeft,
    'icon-right': !!iconRight,
    'with-icon': !!iconLeft || !!iconRight,
    loading: loading,
  });

  const Content = () => {
    return (
      <>
        {iconLeft}
        {loading ? <LoadingEllipse type={type} theme={theme} /> : children}
        {iconRight}
      </>
    );
  };

  return (
    <button
      disabled={disabled || loading}
      className={`${buttonClass} ${className}`}
      onClick={onClick}
      style={style}
    >
      {Content()}
    </button>
  );
};

export default Button;
